export const environment = {
  production: false,
  debug: true,
  APP_ROLE: 'admin' as const,
  INCLUB_RIBERA_API: 'https://api-dev.cieneguillariberadelrio.com',
  WALLET_MICROSERVICE_API: 'https://walletapi-dev.cieneguillariberadelrio.com',
  CMS_MICROSERVICE_API: 'https://cmsapi-dev.cieneguillariberadelrio.com',
  BOOKING_MICROSERVICE_API: 'https://bookingapi-dev.cieneguillariberadelrio.com',
  ROOM_MICROSERVICE_API: 'https://roomapi-dev.cieneguillariberadelrio.com',
  DOCUMENT_STORAGE_API: 'https://documentapi-dev.cieneguillariberadelrio.com',
  NIUBIZ_BUTTON_API:
    'https://static-content-qas.vnforapps.com/v2/js/checkout.js?qa=true',
  MERCHANT_ID: 456879852,
  URL_BACKOFFICE_INCLUB: 'https://www.inclub.world/backoffice',
  PROMOTIONS_RIBERA_API:
    'https://promotionsapi-dev.cieneguillariberadelrio.com',
  ACCOUNT_MICROSERVICE_API:
    'https://accountapi-dev.cieneguillariberadelrio.com',
  SECURITY_MICROSERVICE_API:
    'https://securityapi-dev.cieneguillariberadelrio.com',
  PAYMENT_MICROSERVICE_API:
        'https://paymentapi-dev.cieneguillariberadelrio.com',
  // GTM Configuration
  NOTIFICATION_MICROSERVICE_API:
    'https://notificationsapi-dev.cieneguillariberadelrio.com',
  PROMOTERS_MICROSERVICE_API:
    'https://promotersapi-dev.cieneguillariberadelrio.com',
  SURVEY_MICROSERVICE_API:
    'https://surveyapi-dev.cieneguillariberadelrio.com',
  FILE_SCANNER_API: 'https://filescannerapi-dev.cieneguillariberadelrio.com',
  EVENT_PRODUCTS_MICROSERVICE_API: 'https://eventsapi-dev.cieneguillariberadelrio.com',
  INVENTORY_MICROSERVICE_API: 'https://inventoryapi-dev.cieneguillariberadelrio.com',
  ADMIN_PANEL_API: 'https://adminpanelapi.inclub.world',
  CONCILIATION_MICROSERVICE_API:
    'https://conciliationapi-dev.cieneguillariberadelrio.com',
  ACCOUNTING_MICROSERVICE_API:
    'https://accountingapi-dev.cieneguillariberadelrio.com',
  WAREHOUSE_MICROSERVICE_API:
    'http://localhost:8085',
  features: {
    aiVoucherCheckout: true,
    partialPayments: true,
    newPaymentManager: true,
    izipayEnabled: true,
    niubizEnabled: false,
  },
  gtm: {
    id: '',
  },
};
